/**
 * Persistence key for the selected Roadmapper workspace. `api.ts` reads this
 * same key (via buildBrowserWorkspaceResourceHeaders) so every authenticated
 * request is scoped to the workspace the shell has selected, and the
 * TopoloAppRoot workspace resource writes it. Keep the two in lockstep.
 *
 * Kept in its own module (no import of `api.ts`) so the api client can read the
 * key without a circular import.
 */
export const ROADMAPPER_WORKSPACE_STORAGE_KEY = 'topolo-roadmapper:workspace';

// There is deliberately no app-local workspace shape here any more. The
// workspace record — name, slug, default flag, owner — is the platform's, and
// `TopoloWorkspace` from @topolo-io/app-shell is the one type for it. An
// app-local copy is how a name gets written back and lost.
